module.exports = __webpack_public_path__ + "assets/img/AppIcon.96589096.png";